import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "use", "external", "assetCoordinates", "strategyId", "disabled", "trackUsage"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import useContentEditorUrl from 'personalization-lib/hooks/nav/useContentEditorUrl';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Deduplicate with AssetEditorLink
const EditContentButton = _ref => {
  let {
      label,
      use,
      external,
      assetCoordinates,
      strategyId,
      disabled,
      trackUsage
    } = _ref,
    styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const editorUrl = useContentEditorUrl({
    assetCoordinates,
    strategyId
  });
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: editorUrl,
    onClick: trackUsage,
    use: use,
    external: external,
    disabled: disabled || !assetCoordinates
  }, styleProps, {
    children: label !== null && label !== void 0 ? label : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.navigation.editContentButton.label"
    })
  }));
};
export default EditContentButton;